import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import PageHeader from '../components/PageHeader';
import './Beneficiaires.scss';

const Beneficiaires = () => {
  const navigate = useNavigate();
  const services = [
    {
      icon: (
        <svg viewBox="0 0 50 50" fill="none" stroke="currentColor" strokeWidth="2.5">
          <circle cx="25" cy="15" r="8"/>
          <path d="M10 45 Q10 30 25 30 Q40 30 40 45"/>
        </svg>
      ),
      title: 'Espace Bénéficiaire',
      description: 'Accédez à votre espace personnel pour gérer vos inscriptions, suivre vos programmes et accéder à vos ressources.',
      link: '/inscription',
      color: '#3B5BA5'
    },
    {
      icon: (
        <svg viewBox="0 0 50 50" fill="none" stroke="currentColor" strokeWidth="2.5">
          <rect x="8" y="12" width="34" height="26" rx="2"/>
          <path d="M15 22 L22 28 L35 18"/>
        </svg>
      ),
      title: 'Suivi des Dossiers',
      description: 'Consultez l\'état d\'avancement de vos dossiers, candidatures et demandes en temps réel.',
      link: '/inscription',
      color: '#E8731A'
    },
    {
      icon: (
        <svg viewBox="0 0 50 50" fill="none" stroke="currentColor" strokeWidth="2.5">
          <path d="M12 8 L12 42 L38 42 L38 18 L28 8 Z"/>
          <path d="M28 8 L28 18 L38 18"/>
          <path d="M18 24 L32 24"/>
          <path d="M18 30 L32 30"/>
          <path d="M18 36 L28 36"/>
        </svg>
      ),
      title: 'Ressources & Documents',
      description: 'Téléchargez vos documents, certificats, supports de formation et autres ressources pédagogiques.',
      link: '/inscription',
      color: '#D63070'
    }
  ];

  return (
    <div className="beneficiaires-page">
      <PageHeader 
        title="Espace Bénéficiaires" 
        subtitle="Accédez à tous vos services et ressources"
        breadcrumb={['Accueil', 'Bénéficiaires']}
        image="/assets/IMG/etudiants.png"
        hideText={true}
      />

      <div className="beneficiaires-container">
        <div className="intro-section">
          <p>
            Bienvenue dans votre espace bénéficiaire. Ici, vous pouvez gérer votre parcours au sein de la 
            Fondation BE TALENTED, suivre vos programmes, accéder à vos ressources et rester informé de 
            votre progression.
          </p>
        </div>

        <div className="services-grid">
          {services.map((service, index) => (
            <Link key={index} to={service.link} className="service-card-link">
              <div className="service-card" style={{ '--card-color': service.color }}>
                <div className="service-icon" style={{ background: `${service.color}15` }}>
                  {service.icon}
                </div>
                <h3>{service.title}</h3>
                <p>{service.description}</p>
                <button className="access-btn" style={{ background: service.color }}>
                  Accéder
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="white">
                    <path d="M6 4 L10 8 L6 12"/>
                  </svg>
                </button>
              </div>
            </Link>
          ))}
        </div>

        <div className="login-section">
          <div className="login-card">
            <h2>Vous n'avez pas encore de compte ?</h2>
            <p>
              Inscrivez-vous dès maintenant pour bénéficier de nos programmes de formation, d'orientation 
              et d'insertion professionnelle.
            </p>
            <div className="login-buttons">
              <button className="btn-primary" onClick={() => navigate('/inscription')}>Créer un compte</button>
              <button className="btn-secondary" onClick={() => navigate('/connexion')}>Se connecter</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Beneficiaires;
